import React, { useEffect, useState } from 'react';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import InputTypeNumber from '../../../../common/components/InputTypeNumber/InputTypeNumber';
import { Formik, Form } from 'formik';
import {
  getUploadUrlForBusinessAddressProof,
  UploadFileToS3,
  confirmBusinessAddressProofUploaded,
  saveBusinessAddressProof,
  getBusinessAddressProof,
  getStatesList
} from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import PopUp from '../../../../common/components/PopUp/PopUp';
import { GetImgComp } from '../../../UserKyc/UserKycComponent/UserVoterCard/GetImgComp';
import * as _ from 'lodash';
import Styles from '../companyDetails.module.css';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import CommonPincode from '../../../../components/Dashboard-res/CommonComponent/CommonPincode';
import * as Yup from 'yup';

const { input_type } = Styles;
const inputDivClass = 'my-3 mx-2 w-full mx-auto xxl:mr-auto xxl:ml-2';

const withoutHeadName = 'mt-5';
const withHeadName = 'mx-2 w-full mx-auto xxl:mr-auto xxl:ml-2';
const commonInputEffect = { height: '52px', maxWidth: '100%' };
const comonSelectContainerEffect = {
  minHeight: '52px',
  marginBottom: '0px',
  fontSize: '40px',
  alignItems: 'center'
};
const commonDropDownStles = {
  top: '52px',
  color: 'rgba(0,0,0,0.87)',
  fontSize: '16px',
  backgroundColor: '#fff',
  alignItems: 'center',
  fontFamily: 'Roboto',
  fontWeight: 400
};

const selectCommonDisplay = {
  fontSize: '14px',
  padding: '0 25px',
  alignItems: 'center',
  minHeight: '52px'
};

const RentalAgreement = props => {
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [applicantId, setApplicantId] = useState(
    getApplicantionInfo().leadApplicantId
  );
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('loading...');
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);
  const [stateList, setStateList] = useState([]);

  const validationSchema = Yup.object().shape({
    address_line_1: Yup.string()
      .required('required')
      .min(10, 'Too Short!'),
    city: Yup.string().required('required'),
    state: Yup.object().shape({
      value: Yup.string().required('required')
    }),
    pincode: Yup.string()
      .required('required')
      .length(6, 'Must be 6 digit!'),
    pinCoderesolved: Yup.boolean()
      .required('required')
      .oneOf([true], '')
  });

  return (
    <Formik
      initialValues={{
        file: [],
        imgUrl: [],
        state: { label: 'Select State', value: '' },
        reg_no: '',
        area_code: '',
        pincode: '',
        file_link: '',
        address: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(data, { setSubmitting, resetForm }) => {
        props.handleSubmit();
      }}
    >
      {({
        values,
        handleChange,
        errors,
        touched,
        handleBlur,
        setFieldError,
        setFieldValue,
        fileUploadErrors,
        setFieldTouched,
        handleSubmit,
        validateForm
      }) => {
        useEffect(() => {
          getStatesList()
            .then(res => {
              let dict = {},
                total_list = [];
              for (let i = 0; i < res.length; i++) {
                dict = {};
                dict['label'] = res[i].name;
                dict['value'] = res[i].id;
                total_list.push(dict);
              }
              setStateList(total_list);
            })
            .catch(error => {});
        }, []);

        useEffect(() => {
          setPopUpType('loading');
          setPopUpText('getting previous data, Please Wait');
          setShow(true);
          getBusinessAddressProof(leadId, applicantId, 'rental-agreement')
            .then(res => {
              if (res.error) {
                throw new Error(res);
              }
              setShow(false);
              setFieldValue('showPreviousImage', _.get(res, 'links.0.url'));
              setFieldValue(
                'address_line_1',
                `${_.get(res, 'userData.line1', '')}`
              );
              setFieldValue(
                'address_line_2',
                `${_.get(res, 'userData.line2', '')}`
              );
              setFieldValue('city', `${_.get(res, 'userData.city', '')}`);
              setFieldValue('state', {
                value: `${_.get(res, 'userData.state', '')}`,
                label: `${_.get(res, 'userData.state', 'Select State')}`
              });
              setFieldValue('pincode', `${_.get(res, 'userData.pinCode', '')}`);
            })
            .catch(error => {
              setPopUpType('fail');
              setPopUpText(
                _.get(error, 'response.data.message', 'something went wrong')
              );
              setShow(true);
            });
        }, []);

        const feddBackofUploadedFile = data => {
          confirmBusinessAddressProofUploaded(
            leadId,
            applicantId,
            data.requestId,
            'rental-agreement'
          )
            .then(res => {
              if (res.error) {
                throw new Error(res.error.data.message);
              }
              setShow(false);
            })
            .catch(async err => {
              await setPopUpType('fail');
              await setPopUpText(err.toString());
              setShow(true);
            });
        };

        const uploadFileToS3 = (data, file) => {
          if (data.url && data.requestId) {
            UploadFileToS3(data.url, file)
              .then(res => {
                if (res.error) {
                  throw new Error(res.error.data.message);
                }
                feddBackofUploadedFile(data);
              })
              .catch(async err => {
                await setPopUpType('fail');
                await setPopUpText(err.toString());
                setShow(true);
              });
          }
        };

        useEffect(() => {
          const handleUpload = async () => {
            let file = values.file[values.UploadRent][0];

            await setPopUpType('loading');
            await setPopUpText('Uploading File...');
            setShow(true);

            getUploadUrlForBusinessAddressProof(
              leadId,
              applicantId,
              'rental-agreement'
            )
              .then(res => {
                if (res.error) {
                  throw new Error(res.error.data.message);
                }
                uploadFileToS3(res, file);
              })
              .catch(async err => {
                await setPopUpType('fail');
                await setPopUpText(err.toString());
                setShow(true);
              });
          };
          if (values.file[values.UploadRent]) {
            handleUpload();
          }
        }, [values.file[values.UploadRent]]);

        const submitValues = () => {
          setPopUpType('loading');
          setPopUpText('submitting Data Please Wait...');
          setShow(true);
          let body = {
            line1: values.address_line_1,
            line2: values.address_line_2,
            city: values.city,
            state: values.state.label,
            pinCode: values.pincode
          };

          saveBusinessAddressProof(
            getApplicantionInfo().leadId,
            getApplicantionInfo().leadApplicantId,
            body,
            'rental-agreement'
          )
            .then(res => {
              setShow(false);
              handleSubmit();
            })
            .catch(error => {
              setPopUpType('fail');
              setPopUpText(
                _.get(error, 'response.data.message', 'something went wrong!')
              );
              setShow(true);
            });
        };

        const handleSubmition = () => {
          validateForm().then(res => {
            if (Object.keys(res).length == 0) {
              submitValues();
            } else {
              handleSubmit();
            }
          });
        };

        return (
          <Form>
            <div className="bg-white w-full px-2 ">
              <p className="md:hidden block font-roboto font-normal text-grey-1009 mr-auto py-3 text-sm">
                Upload Rental agreement
              </p>
              <div className=" w-auto  lg:px-5  md:mx-auto ">
                <div
                  className="block mx-auto w-full"
                  style={{ width: 'fit-content' }}
                >
                  <p className="font-roboto font-normal text-black-600 text-sm pb-5">
                    {values.showPreviousImage
                      ? 'Rental Agreement'
                      : 'Upload Rental agreement'}
                  </p>
                  {/* {values.showPreviousImage.toString()} */}
                  {values.showPreviousImage && !edit ? (
                    <GetImgComp
                      imgUrl={values.showPreviousImage}
                      setEdit={setEdit}
                    />
                  ) : (
                    <GlobalUploadComp
                      data={values}
                      imgIndex={values.UploadRent} //0,1,2,3 depending upon the no of file sequence
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      subInst="Click here Upload Front Page of Rental Aagreement"
                      subtext="Upload "
                    />
                  )}
                </div>
              </div>
              <div className="block mx-auto w-full my-4">
                <div
                  className={`${inputDivClass} ${input_type} ${withoutHeadName}`}
                >
                  <CommonInput
                    name="address_line_1"
                    disabled=""
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.address_line_1}
                    stylesContainer={commonInputEffect}
                    legendName="Address Line 1"
                    error={touched.address_line_1 && errors.address_line_1}
                    errorMsg={errors.address_line_1}
                    touched={touched.address_line_1}
                  />
                </div>
                <div
                  className={`${inputDivClass} ${input_type} ${withoutHeadName}`}
                >
                  <CommonInput
                    name="address_line_2"
                    disabled=""
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.address_line_2}
                    stylesContainer={commonInputEffect}
                    legendName="Address Line 2"
                    error={touched.address_line_2 && errors.address_line_2}
                    errorMsg={errors.address_line_2}
                    touched={touched.address_line_2}
                  />
                </div>
                <div
                  className={`${inputDivClass} ${input_type} ${withoutHeadName} `}
                >
                  <CommonInput
                    name="city"
                    disabled=""
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.city}
                    stylesContainer={commonInputEffect}
                    legendName="City"
                    error={touched.city && errors.city}
                    errorMsg={errors.city}
                    touched={touched.city}
                  />
                </div>

                <div className={` ${input_type} ${withHeadName}`}>
                  <div className="text-black-600 font-roboto font-normal text-xs pb-1 md:py-0">
                    State
                  </div>

                  <CommonSelect sort={true}
                    name="state"
                    value={values.state}
                    onChange={e => {
                      setFieldValue('state', {
                        value: e.value,
                        label: e.label
                      });
                    }}
                    onBlur={handleBlur}
                    options={stateList}
                    isHoverEffect
                    stylesContainer={comonSelectContainerEffect}
                    dropdownStyle={commonDropDownStles}
                    styleText={selectCommonDisplay}
                    error={touched.state && _.get(errors, 'state.value', false)}
                    touched={touched.state}
                    onBlur={() => {}}
                  />
                </div>
                <div
                  className={`${inputDivClass} ${input_type} ${withoutHeadName}`}
                >
                  <CommonPincode
                    name="pincode"
                    value={values.pincode}
                    onChange={e => {
                      if (
                        e.target.value.length <= 6 &&
                        !isNaN(e.target.value)
                      ) {
                        handleChange(e);
                        setFieldValue('pinCoderesolved', false);
                      }
                    }}
                    stylesContainer={{
                      minHeight: '52px',
                      maxWidth: '100%'
                    }}
                    error={
                      _.get(errors, 'pincode', false) &&
                      _.get(touched, 'pincode', false)
                    }
                    errorMsg={_.get(errors, 'pincode', false)}
                    touched={_.get(touched, 'pincode', false)}
                    onPinCodeSucessOrFailure={obj => {
                      const { err, data: pincodeData } = obj;

                      if (!err && pincodeData) {
                        setFieldValue('pincodeCity', pincodeData.District),
                          setFieldValue('pincodeState', pincodeData.State);
                        setFieldValue('pinCoderesolved', true);
                      } else {
                        setFieldError('pincode', 'Pincode is not valid');
                      }
                    }}
                    onBlur={e => {
                      handleBlur(e);
                    }}
                  />
                  {values.pinCoderesolved || errors.pincode ? (
                    <p
                      className={
                        (errors.pincode ? 'text-red-500' : 'text-green-500') +
                        ' pt-2 text-xs'
                      }
                    >
                      {errors.pincode
                        ? null
                        : values.pincodeCity + ',   ' + values.pincodeState}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="w-full my-6 ">
                <button
                  type="button"
                  className="submitButton fonåt-roboto text-white text-base w-48 "
                  disabled={Object.keys(errors).length != 0 ? true : false}
                  onClick={handleSubmition}
                >
                  NEXT
                </button>
              </div>

              <PopUp
                type={popUpType}
                text={popUpText}
                setShow={setShow}
                show={show}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default RentalAgreement;
